<template>
    <div>
        logout
    </div>
</template>

<script>
  export default {
    name: 'logout'
  }
</script>

<style scoped>

</style>
